export const BASE_ENV = 'STAGING';
